import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromPublisSessionState from './publis-session-state.reducer';

export const selectPublisSessionStateState = createFeatureSelector<fromPublisSessionState.State>(
  fromPublisSessionState.publisSessionStateFeatureKey
);

export const selectSearchPhrase = createSelector(
  selectPublisSessionStateState,
  (state: fromPublisSessionState.State) => state.searchPhrase
);
export const selectMatchList = createSelector(
  selectPublisSessionStateState,
  (state: fromPublisSessionState.State) => state.searchMatch
);
